import React, { useState, useEffect } from "react";
import Button from "../../../components/Button";
import InputSelect from "../../../components/InputSelect";
import Modal from "../../../components/Modal";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import Input from "../../../components/Input";
import { hasPermission } from "../../../services/auth";

function unmaskCurrencyToInt(value) {
    if (!value) return 0;
  
    const cleaned = value
      .replace(/[R$\s.]/g, '')
      .replace(',', '');
  
    return parseInt(cleaned, 10);
  }

export const ModalFilter = ({showFilter, setShowFilter, setCustomFilters, setCurrentPage}) => {
    const [customizations, setCustomizations] = useState([]);
    const [categories, setCategories] = useState([]);
    const [tags, setTags] = useState([]);
    const [suppliers, setSuppliers] = useState([]);

    const [name, setName] = useState(null);
    const [status, setStatus] = useState(null);
    const [sku, setSku] = useState(null);
    const [companySku, setCompanySku] = useState(null);
    const [category, setCategory] = useState(null);
    const [companyId, setCompanyId] = useState(null);
    const [featured, setFeatured] = useState(null);
    const [recent, setRecent] = useState(null);
    const [tagId, setTagId] = useState(null);
    const [image, setImage] = useState(null);
    const [customization, setCustomization] = useState(null);
    const [minPrice, setMinPrice] = useState(null);
    const [maxPrice, setMaxPrice] = useState(null);
    const [minStock, setMinStock] = useState(null);
    const [minQuantity, setMinQuantity] = useState(null);

    useEffect(() => {
     /*   getCustomizations();
        getCategories();
        getTags();*/
        getSuppliers();
    }, []);

    useEffect(() => {
        console.log(category)
    }, [category]);

    const getCustomizations = () => {
        api.get(`/customization`).then(res => {
            setCustomizations(res.data.resources);
        });
    }

    const getSuppliers = () => {
        api.get(`/company/paginate?&filters[0][type][contain]=product&per_page=9999`).then(res => {
            setSuppliers(res.data.resources.data);
        });
    }

    const getCategories = () => {
        api.get(`/category`).then(res => {
            let toCategories = [];
            res.data.resources.map(category => {
                toCategories.push(category);
                category.categories.map(subcategory => toCategories.push({
                    ...subcategory,
                    name: `${category.name} > ${subcategory.name}`
                }));
            });
            setCategories(toCategories);
        });
    }

    const getTags = () => {
        api.get(`/tag`).then(res => {
            setTags(res.data.resources);
        });
    }

    const isTrue = [
        { label: 'Sim', value: '1' },
        { label: 'Não', value: '0' }
    ];

    const activeStatus = [
        { label: 'Ativo', value: '1' },
        { label: 'Inativo', value: '0' }
    ];

    const categoryOptions = [
        { label: 'Todas as categorias', value: null },
        { label: 'Sem categoria', value: 'without_categories' },
        ...createOptions(categories, 'name', 'id'),
    ];    

    const customizationOptions = [
        { label: 'Todas as gravações', value: null },
        { label: 'Sem gravações', value: 'without_customization' },
        ...createOptions(customizations, 'name', 'id'),
    ];        
    
    const handleClear = () => {
        setCustomFilters('');
        setCurrentPage(1);
        setName(null);
        setStatus(null);
        setSku(null);
        setCompanySku(null);
        setCategory(null);
        setCompanyId(null);
        setFeatured(null);
        setRecent(null);
        setTagId(null);
        setImage(null);
        setCustomization(null);
        setMinPrice(null);
        setMaxPrice(null);
        setMinStock(null);
        setMinQuantity(null);
    }

    const handleFilter = () => {
        let text = '';

        if (name !== null) {
            text += `&filters[0][name][contain]=${name}`;
        }
        if (status !== null) {
            text += `&filters[0][status][equal]=${status}`;
        }
        if (sku !== null) {
            text += `&filters[0][sku][contain]=${sku}`;
        }
        if (companySku !== null) {
            text += `&filters[0][company_sku][contain]=${companySku}`;
        }
        if (category !== null) {
            text += `&filters[0][related][categories.id][equal]=${category}`;
        }
        if (companyId !== null) {
            text += `&filters[0][company_id][equal]=${companyId}`;
        }
        if (featured !== null) {
            text += `&filters[0][featured][equal]=${featured}`;
        }
        if (recent !== null) {
            text += `&filters[0][recent][equal]=${recent}`;
        }
        if (tagId !== null) {
            text += `&filters[0][tag_id][equal]=${tagId}`;
        }
        if (image !== null) {
            text += `&filters[0][image][equal]=${image}`;
        }
        if (customization !== null) {
            text += `&filters[0][related][customizations.id][equal]=${customization}`;
        }
        if (minPrice !== null) {
            if (unmaskCurrencyToInt(minPrice) !== 0) {
                text += `&filters[0][price][bigger_or_equal]=${unmaskCurrencyToInt(minPrice)}`;
            }
        }
        if (maxPrice !== null) {
            text += `&filters[0][price][less_or_equal]=${unmaskCurrencyToInt(maxPrice)}`;
        }
        if (minStock !== null) {
            text += `&filters[0][stock][bigger_or_equal]=${minStock}`;
        }
        if (minQuantity !== null) {
            text += `&filters[0][min_quantity][bigger_or_equal]=${minQuantity}`;
        }
        setCustomFilters(text);
        setShowFilter(false);
    }
    
    return (
        <Modal
            show={showFilter}
            close={() => setShowFilter(false)}
            title={`Filtrar`}
            footer={
                <>
                    <Button
                        type={`secondary`}
                        size={`small`}
                        text={`Limpar filtros`}
                        action={handleClear}
                    />
                    <Button
                        type={`primary`}
                        size={`small`}
                        text={`Filtrar resultados`}
                        action={handleFilter}
                    />
                    
                </>
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col">
                        <Input 
                            label={`Nome`}
                            value={name}
                            change={setName}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Input 
                            label={`SKU`}
                            value={sku}
                            change={setSku}
                        />
                    </div>
                    {/*<div className="col-6">
                        <Input 
                            label={`SKU do fornecedor`}
                            value={companySku}
                            change={setCompanySku}
                        />                        
                    </div>*/}
                </div>
                <div className="row">
                    <div className="col-6">
                        <InputSelect label={`Status`} options={activeStatus} value={status} change={setStatus} />
                    </div>
                   {/* <div className="col-6">
                        <InputSelect label={`Categoria`} 
                            options={categoryOptions} 
                            value={
                                category === 'without_categories'
                                ? 'without_categories'
                                : category === null
                                ? null
                                : category
                            } 
                            getOptionLabel={option =>
                                option.value === 'without_categories' 
                                ? 'Sem categoria' 
                                : option.value === null 
                                ? 'Todas as categorias' 
                                : option.label
                            }
                            change={setCategory} 
                        />
                    </div> */}
                </div>               
                {/* <div className="row">
                    <div className="col-4">
                        <InputSelect label={`Destaque`} 
                            options={isTrue} 
                            value={featured} 
                            change={setFeatured} 
                        />
                    </div>
                    <div className="col-4">
                        <InputSelect label={`Novidade`} 
                            options={isTrue} 
                            value={recent} 
                            change={setRecent}
                        />                        
                    </div>
                    <div className="col-4">
                        <InputSelect label={`Tag`} 
                            options={createOptions(tags, 'text', 'id', true)} 
                            value={tagId} 
                            change={setTagId} 
                        />
                    </div>
                </div>     */ }           
                <div className="row">
                    <div className="col">
                    <InputSelect 
                        label={`Gravação`} 
                        options={customizationOptions} 
                        value={
                            customization === 'without_customization'
                            ? 'without_customization'
                            : customization === null
                            ? null
                            : customization
                        } 
                        change={setCustomization} 
                        getOptionLabel={option =>
                            option.value === 'without_customization'
                            ? 'Sem gravação'
                            : option.value === null
                            ? 'Todas as gravações'
                            : option.label
                        }
                    />
                    </div>
                </div> 
              {/*  <div className="row">
                    <div className="col">
                        <InputSelect label={`Fornecedor`} 
                            options={createOptions(suppliers, 'company_name', 'id', true)} 
                            value={companyId} 
                            change={setCompanyId} 
                        />
                    </div>
                </div>
                {hasPermission('show_product_supplier_price_in_budget') &&
                    <div className="row">
                        <div className="col-6">
                            <Input
                                label={`Preço a partir de`}
                                value={minPrice}
                                change={setMinPrice}
                                mask={'convertToMoney'}
                            />
                        </div>
                        <div className="col-6">
                            <Input
                                label={`Preço até`}
                                value={maxPrice}
                                change={setMaxPrice}
                                mask={'convertToMoney'}
                            />
                        </div>
                    </div> 
                }
                <div className="row">
                    <div className="col-6">
                        <Input
                            label={`Estoque mínimo`}
                            value={minStock}
                            change={setMinStock}
                            mask={'convertToInt'}
                        />
                    </div>
                    <div className="col-6">
                        <Input
                            label={`Quantidade mínima a partir de`}
                            value={minQuantity}
                            change={setMinQuantity}
                            mask={'convertToInt'}
                        />
                    </div>
                </div> */}
            </div>
        </Modal>
    )
}